// 检测state
const state = {
  paperType: 'newPaper', // 文献类型
  checkType: 'upload' // 检测类型
};
// 修改state
const mutations = {
  changePaperType(states: any, paperType: string) {
    states.paperType = paperType;
  },
  changeCheckType(states: any, checkType: string) {
    states.checkType = checkType;
  }
};
// 外部调用修改state
const actions = {
  setPaperType(context: any, paperType: string) {
    context.commit('changePaperType', paperType);
  },
  setCheckType(context: any, checkType: string) {
    context.commit('changeCheckType', checkType);
  }
};
// 外部调用获取state
const getters = {
  getPaperType(states: any) {
    return states.paperType;
  },
  getCheckType(states: any) {
    return states.checkType;
  }
};
export default {
  // 公共state
  state,
  // 修改state
  mutations,
  // 外部调用修改state
  actions,
  // 外部调用获取state
  getters
};
